export const TARGET2_REMOVE_CONFIRM = 'target2.confirm'
